let Routing = {
    ROUTING: 'ROUTING',
};

export default Routing;
